const STREAK_MILESTONES = [3, 5, 10, 30, 50, 100, 200, 365, 500];

export const isStreakMilestone = (streakDays: number): boolean => {
  return STREAK_MILESTONES.includes(streakDays);
};
